import type { ScreenerFilter } from '@api';
import type { FilterVariant } from '@terminal/components/filter/include-exclude/include-exclude.types';
import {
  countryExposureFilterKey,
  themeExposureFilterKey,
} from '@terminal/config/constants';

const INCLUDE_EXCLUDE_SINGLE_SELECT_FILTER_KEYS = new Set([
  themeExposureFilterKey,
  countryExposureFilterKey,
]);

export const isExcludableSectorFilter = (
  filter: Pick<ScreenerFilter, 'key' | 'excludable'>
) => filter.key === 'gics' && filter.excludable === true;

export const getFilterVariant = (filter: ScreenerFilter): FilterVariant => {
  if (
    (filter.key === 'market' && filter.excludable) ||
    isExcludableSectorFilter(filter)
  ) {
    return 'include-exclude-multiselect';
  }

  if (
    filter.dynamic &&
    filter.excludable &&
    INCLUDE_EXCLUDE_SINGLE_SELECT_FILTER_KEYS.has(filter.key)
  ) {
    return 'include-exclude-single-select';
  }

  return 'default';
};
